import CheckIcon from '@mui/icons-material/Check';
import { useTheme, Stack } from '@mui/material';

export default function Check({value, size}){

    const theme = useTheme();

    let s = size || 14;

    let sx = {
        background: value ? theme.palette.primary.main : 'transparent',
        border: 'solid 2px',
        borderColor: value ? theme.palette.primary.main : 'rgb(150,150,150)',
        width: s,
        minWidth: s,
        height: s,
        borderRadius: '50%'
    };

    return <Stack direction='row' justifyContent='center' alignItems='center' sx={sx}>
        {value && <CheckIcon sx={{color: 'white', fontSize: s}} />}
    </Stack>
}